const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath)
  if (value.default) modules.push(value.default)
  // 提供侧栏排序
  return modules.sort((a, b) => a.sort - b.sort)
}, [])

// 导出所有权限集
// function getPermissionList(data) {
//   const arr = []
//   for (let i = 0, len = data.length; i < len; i++) {
//     const obj = {
//       name: data[i].meta.title,
//       permission: data[i].meta.roles[0]
//     }
//     if (Object.hasOwnProperty.call(data[i], 'children') && data[i].children.length) {
//       obj.children = getPermissionList(data[i].children)
//     }
//     arr.push(obj)
//   }
//   return arr
// }

// const data = getPermissionList(modules)
// console.log(JSON.stringify(data))

export default modules



// WEBPACK FOOTER //
// ./src/router/router-modules.js